
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Experience a magical night cruise in Goa, with sparkling views, great food, and a lively atmosphere. Perfect for a fun evening with family or friends.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the excitement of a night cruise in Goa, offering stunning views under the stars, delicious dining, and a memorable time with loved ones.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy a night cruise in Goa, with great food, amazing views, and a vibrant atmosphere. Ideal for a fun night out with friends or family!',
},


        {
          hid: 'keywords',
          name: 'keywords',
          content: 'night cruise in goa, night cruise in goa price, best night cruise in goa, one night cruise in goa, chapora river night cruise in goa',
        },
      
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],

      title: 'Night Cruise in Goa - Night Cruise in Goa Price',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/night-cruise-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/night-cruise-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/night-cruise-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Night Cruise Goa - Book @ ₹1299 Flat 50% Off",
  "description": "Experience a Night Cruise in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1299",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/night-cruise-goa",
        "url": "https://www.goa.app/night-cruise-goa",
        "name": "Night Cruise Goa ",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-02-28T06%3A51%3A34.599Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=kZHku7DtvcNMWECPR3PVkvGRmMi%2BqNR%2FqypgW7khhag4StsMNmNYmzABXpD0GzJgO0t2O64NgYiB9OGoI1LKYIwDdeSrgrrfaTxt%2FyFIO4z5rEPmAsW%2BG5Couz%2FB00Ey4Jh7kB%2FsiaQqBTQQ7MmpDxyh3eu8rUxLQQ0h0bXm1SHH1fDaN%2F84vwA7d%2BO204uQQ7cd4%2Ft3u1UC15KYPRYGeST%2B%2BrrG%2FiY6JVePcWVWwTxef93glTNrC4P9CiIkiLuT2trXyiEptQSsx1HlIoObiIy5pD1v67pnjDFszwFVwU%2FgVtErhZuPgXjP61aq%2F4c7bJV93YUWi7r0ztPZ%2Bcicsg%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Night Cruise in Goa offers a memorable experience with scenic views, lively entertainment, and great vibes. Ideal for celebrations or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while partying along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/night-cruise-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/night-cruise-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
  "@type": "Question",
  "name": "How do I book a Night Cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "You can book a Night Cruise in Goa through various online platforms or by contacting local operators. Booking in advance, especially during peak season, is recommended to secure your spot."
  }
},
{
  "@type": "Question",
  "name": "What is included in a Night Cruise in Goa package?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Night Cruise in Goa packages typically include the cruise, crew, and basic amenities. Some packages offer extras like meals, beverages, and entertainment on board."
  }
},
{
  "@type": "Question",
  "name": "What should I wear for a Night Cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "It’s recommended to wear comfortable, smart casual attire. Dress for the weather and don't forget your swimwear if you plan to take a dip or engage in water activities."
  }
},
{
  "@type": "Question",
  "name": "How long can I enjoy the Night Cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Night Cruises in Goa can last anywhere from a couple of hours to a full night, depending on the package. Longer cruises for special occasions can often be arranged."
  }
},
{
  "@type": "Question",
  "name": "Can I customize the experience on a Night Cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many operators allow customization for special occasions such as birthdays or anniversaries. You can add elements like decorations, meals, and entertainment."
  }
},
{
  "@type": "Question",
  "name": "Are meals and drinks included in the Night Cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Night Cruises in Goa include meals and drinks, while others may offer them as an optional add-on. It's best to confirm with the cruise provider when booking."
  }
},
{
  "@type": "Question",
  "name": "What is the price range for Night Cruises in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Prices for Night Cruises in Goa typically start from ₹500 and can go up depending on the duration, inclusions, and amenities offered."
  }
},
{
  "@type": "Question",
  "name": "Can I book a Night Cruise in Goa for a special occasion?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, Night Cruises in Goa are perfect for special occasions like anniversaries or celebrations. Many operators offer tailor-made packages for such events."
  }
},
{
  "@type": "Question",
  "name": "What is the best time to book a Night Cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The best time to book a Night Cruise in Goa is between November and February when the weather is pleasant. However, cruises are available year-round for a memorable experience."
  }
},
{
  "@type": "Question",
  "name": "Can I bring my own food and drinks on a Night Cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Night Cruise operators allow you to bring your own food and beverages, while others provide catering services. It's advisable to check with the provider in advance."
  }
},
{
  "@type": "Question",
  "name": "Are Night Cruises in Goa suitable for water sports?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many Night Cruises in Goa offer additional water sports activities such as jet skiing and fishing. You can inquire about these options when booking your cruise."
  }
}


]
      }
    ]
  };
},


};


  